import { render, staticRenderFns } from "./HourlyRateKPM.vue?vue&type=template&id=69db1528"
import script from "./HourlyRateKPM.vue?vue&type=script&lang=js"
export * from "./HourlyRateKPM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69db1528')) {
      api.createRecord('69db1528', component.options)
    } else {
      api.reload('69db1528', component.options)
    }
    module.hot.accept("./HourlyRateKPM.vue?vue&type=template&id=69db1528", function () {
      api.rerender('69db1528', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/reports/HourlyRateKPM.vue"
export default component.exports